<style scoped lang="scss">

</style>

<template>
    <div class="uk-width-1-1 uk-grid">
        <div class="uk-width-1-1 uk-margin-large-top uk-margin-large-bottom">
            <header-row></header-row>
            <h3>This Page Intentionally Left Blank</h3>
        </div>

        <div class="uk-width-1-1">&nbsp;</div>
    </div>
</template>

<script>
    import HeaderRow from "./HeaderRow";
    export default {
        name: "BlankPage",
        components: {HeaderRow}
    }
</script>
